export default __webpack_public_path__ + "videos/particle-glow-trail-silver-1440w.2208c0178623d4ca2595df72a2ca0012.webm";